/* TOPPIK - convivenza widget flottanti (LIVE 6.6, v5)
   v5 (17/10): launcher e pannello Rivo Loyalty forzati in BASSO A SINISTRA (chat IA in
   basso a destra, linguetta promo 10% laterale a sinistra a meta altezza). Conviene
   impostare la stessa posizione anche in Rivo > Onsite > Floating Widget (desktop e mobile).
   v4: la chat IA "Toppik Italia AI" si presenta SOLO come icona tonda in basso a destra
   (#tpk-ai-fab, creata qui). Il launcher nativo di Shopify (pill con testo e fumetti di
   invito) resta nascosto finche la chat e chiusa; l'icona apre la chat cliccando il
   launcher nativo (button.activator nello shadow DOM), con fallback su show() e
   sull'attributo open. Se la chat non si registra (app spenta) l'icona non compare.
   Se lo shadow DOM non e accessibile, resta il launcher nativo e l'icona non viene creata.
   Problema: chat IA di Shopify (<shopify-chat>, "Acquista con l'intelligenza artificiale"),
   launcher regali (Rivo / BOGOS), linguetta promo e barre fisse in basso si sovrappongono,
   con posizioni diverse a ogni larghezza (pill a tutta larghezza su mobile, cerchio
   minimizzato in basso a destra, pill centrata su desktop).
   Approccio: nessun selettore di app da indovinare e nessun breakpoint fisso. A ogni
   controllo lo script misura TUTTI gli elementi position:fixed visibili nella parte bassa
   dello schermo (esclusi header, drawer del tema, dialog e barra di anteprima Shopify) e:
   1. Mini-carrello aperto: nasconde chat e widget flottanti (riepilogo e wallet liberi).
   2. Chat aperta: nasconde i widget flottanti finche resta aperta.
   3. Pannello di un widget aperto (es. pannello regali, popup): nasconde il pulsante chat.
   4. A riposo: ogni launcher che tocca un ostacolo (pulsante chat, barra fissa a tutta
      larghezza come lo sticky "Aggiungi al carrello") sale sopra l'ostacolo con 12 px di
      distacco. Spostamento con la proprieta CSS "translate", che si somma alle
      trasformazioni dell'app senza sovrascrivere left/right/bottom.
   Vale a ogni larghezza e orientamento: si ricalcola su resize e ogni 400 ms.
   Debug: ?tpkdock=1 nell'URL stampa in console cosa e stato misurato. */
(function () {
  'use strict';
  if (window.__tpkDock) return;
  window.__tpkDock = 5;

  var GAP = 12;
  var DEBUG = /[?&]tpkdock=1/.test(location.search);
  var EXCL = '#cart-drawer,#chat-drawer,shopify-chat,#tpk-ai-fab,header,dialog,[data-tpk-header],' +
             '#header-group,#preview-bar-iframe,[id*="PBar"],[id*="preview-bar"],[class*="preview-bar"]';
  var root = document.documentElement;
  var cands = [];          /* elementi fixed candidati (radici piu esterne) */
  var lifted = new Map();  /* elemento -> px di sollevamento applicati */
  var hiddenSet = [];
  var raf = 0, lastScan = 0;

  var css = document.createElement('style');
  css.id = 'tpk-dock-css';
  css.textContent =
    'html:has(#cart-drawer[open]) shopify-chat,html:has(#cart-drawer>dialog[open]) shopify-chat,' +
    'html.tpk-dock-cart shopify-chat,html.tpk-dock-panel shopify-chat:not([open]){display:none!important}' +
    '.tpk-dock-hide{display:none!important}' +
    /* icona tonda Toppik Italia AI */
    'html.tpk-ai-on shopify-chat:not([open]){display:none!important}' +
    '#tpk-ai-fab{position:fixed;z-index:2147482000;right:max(20px,env(safe-area-inset-right,0px));' +
    'bottom:calc(20px + env(safe-area-inset-bottom,0px));width:56px;height:56px;border-radius:50%;border:0;padding:0;' +
    'display:flex;align-items:center;justify-content:center;background:#141414;color:#fff;cursor:pointer;' +
    'box-shadow:0 6px 18px rgba(0,0,0,.22);transition:transform .2s ease,opacity .2s ease;-webkit-tap-highlight-color:transparent}' +
    '#tpk-ai-fab svg{width:26px;height:26px;display:block}' +
    '@media (hover:hover){#tpk-ai-fab:hover{transform:translateY(-2px)}}' +
    '#tpk-ai-fab:focus-visible{outline:2px solid #b98a3f;outline-offset:3px}' +
    '@media (max-width:767px){#tpk-ai-fab{width:52px;height:52px;right:max(16px,env(safe-area-inset-right,0px));bottom:calc(16px + env(safe-area-inset-bottom,0px))}#tpk-ai-fab svg{width:24px;height:24px}}' +
    'html:has(shopify-chat[open]) #tpk-ai-fab,html:has(#chat-drawer[open]) #tpk-ai-fab,' +
    'html:has(#cart-drawer[open]) #tpk-ai-fab,html:has(#cart-drawer>dialog[open]) #tpk-ai-fab,' +
    'html.tpk-dock-cart #tpk-ai-fab,html.tpk-dock-chat #tpk-ai-fab,html.tpk-dock-panel #tpk-ai-fab{display:none!important}' +
    /* Rivo in basso a sinistra (selettori documentati da Rivo) */
    '#launcher-wrapper{left:max(20px,env(safe-area-inset-left,0px))!important;right:auto!important}' +
    '@media (min-width:768px){.ba-loy-namespace .ba-loy-messenger-frame{left:max(20px,env(safe-area-inset-left,0px))!important;right:auto!important}}' +
    '@media (max-width:767px){#launcher-wrapper{left:max(16px,env(safe-area-inset-left,0px))!important}}' +
    '.tpk-dock-lift{transition:translate .25s ease}' +
    '@media (prefers-reduced-motion:reduce){.tpk-dock-lift{transition:none}}';
  document.head.appendChild(css);

  function cs(el) { try { return getComputedStyle(el); } catch (e) { return null; } }
  function shown(el) {
    var s = cs(el);
    if (!s || s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 20 && r.height > 20;
  }
  function isOpen(id) {
    var d = document.getElementById(id);
    if (!d) return false;
    if (d.hasAttribute('open')) return true;
    var dlg = d.querySelector(':scope > dialog');
    return !!(dlg && dlg.open);
  }

  /* Elenco dei candidati: rifatto al massimo ogni 1,5 s (scansione completa del DOM) */
  function scan() {
    lastScan = Date.now();
    var all = document.body.getElementsByTagName('*'), out = [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i], s = cs(el);
      if (!s || s.position !== 'fixed') continue;
      if (el.closest(EXCL)) continue;
      var inside = false;
      for (var j = 0; j < out.length; j++) { if (out[j].contains(el)) { inside = true; break; } }
      if (!inside) out.push(el);
    }
    cands = out;
  }

  /* Pulsante chat: unione degli elementi fixed visibili nello shadow DOM.
     Se lo shadow DOM non e leggibile: stima per larghezza (pill a tutta larghezza sotto
     768 px, pill centrata da 420 px sopra), alta 96 px dal fondo. */
  function chatRect(chat, vw, vh) {
    var rects = [];
    (function walk(r, d) {
      if (!r || d > 2) return;
      var all = r.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.shadowRoot) walk(el.shadowRoot, d + 1);
        var s = cs(el);
        if (s && s.position === 'fixed' && shown(el)) rects.push(el.getBoundingClientRect());
      }
    })(chat.shadowRoot, 0);
    if (!rects.length) {
      if (!customElements.get('shopify-chat')) return null;
      return vw < 768 ? { left: 0, right: vw, top: vh - 96, bottom: vh }
                      : { left: vw / 2 - 210, right: vw / 2 + 210, top: vh - 96, bottom: vh };
    }
    var u = { left: Infinity, top: Infinity, right: -Infinity, bottom: -Infinity };
    rects.forEach(function (r) {
      u.left = Math.min(u.left, r.left); u.top = Math.min(u.top, r.top);
      u.right = Math.max(u.right, r.right); u.bottom = Math.max(u.bottom, r.bottom);
    });
    return u;
  }

  function setLift(el, dy) {
    if ((lifted.get(el) || 0) === dy) return;
    lifted.set(el, dy);
    el.classList.add('tpk-dock-lift');
    if (dy) el.style.setProperty('translate', '0 ' + (-dy) + 'px', 'important');
    else el.style.removeProperty('translate');
  }
  function hideAll(list, on) {
    list.forEach(function (el) {
      el.classList.toggle('tpk-dock-hide', on);
      var i = hiddenSet.indexOf(el);
      if (on && i < 0) hiddenSet.push(el);
      if (!on && i >= 0) hiddenSet.splice(i, 1);
    });
  }

  function check() {
    raf = 0;
    if (!document.body) return;
    if (Date.now() - lastScan > 1500) scan();
    cands = cands.filter(function (el) { return el.isConnected; });
    lifted.forEach(function (v, el) { if (!el.isConnected) lifted.delete(el); });

    var vw = window.innerWidth, vh = window.innerHeight;
    var chat = document.querySelector('shopify-chat');
    var cartOpen = isOpen('cart-drawer');
    var chatOpen = !!chat && (chat.hasAttribute('open') || isOpen('chat-drawer'));

    /* 1-2: mini-carrello o chat aperti -> widget nascosti */
    root.classList.toggle('tpk-dock-cart', cartOpen);
    root.classList.toggle('tpk-dock-chat', chatOpen && !cartOpen);
    var hideWidgets = cartOpen || chatOpen;
    if (!hideWidgets && hiddenSet.length) hideAll(hiddenSet.slice(), false);

    var launchers = [], bars = [], panel = false;
    cands.forEach(function (el) {
      if (el.classList.contains('tpk-dock-hide')) return;
      if (!shown(el)) return;
      var cur = lifted.get(el) || 0;
      var r = el.getBoundingClientRect();
      var n = { left: r.left, right: r.right, top: r.top + cur, bottom: r.bottom + cur, w: r.width, h: r.height };
      if (n.h > Math.min(320, vh * 0.45)) { panel = true; setLift(el, 0); return; }
      if (n.w >= vw * 0.6 && n.bottom >= vh - 4) { bars.push(n); setLift(el, 0); return; }
      if (n.bottom > vh - 260) launchers.push({ el: el, n: n });
    });

    if (hideWidgets) {
      hideAll(cands.filter(function (el) { return el.classList.contains('tpk-dock-hide') || shown(el); }), true);
      root.classList.remove('tpk-dock-panel');
      log({ cartOpen: cartOpen, chatOpen: chatOpen, hidden: hiddenSet.length });
      return;
    }

    /* 3: pannello di un widget aperto -> pulsante chat nascosto */
    root.classList.toggle('tpk-dock-panel', panel);

    /* 4: launcher sopra pulsante chat e barre fisse */
    var obstacles = bars.slice();
    var c = null;
    var fab = document.getElementById('tpk-ai-fab');
    if (fab && !panel && shown(fab)) { c = fab.getBoundingClientRect(); obstacles.push(c); }
    else if (chat && !panel && cs(chat).display !== 'none') { c = chatRect(chat, vw, vh); if (c) obstacles.push(c); }
    launchers.forEach(function (L) {
      var dy = 0;
      for (var pass = 0; pass < 3; pass++) {
        var top = L.n.top - dy, bottom = L.n.bottom - dy, need = dy;
        obstacles.forEach(function (o) {
          var ox = L.n.left < o.right + GAP && L.n.right > o.left - GAP;
          var oy = bottom > o.top - GAP && top < o.bottom + GAP;
          if (ox && oy) need = Math.max(need, Math.ceil(L.n.bottom - o.top + GAP));
        });
        if (need === dy) break;
        dy = need;
      }
      setLift(L.el, Math.min(dy, Math.round(vh * 0.5)));
    });
    log({ vw: vw, chatRect: c, bars: bars.length, panel: panel,
      launchers: launchers.map(function (L) { return { el: L.el.id || L.el.className || L.el.tagName, lift: lifted.get(L.el) || 0 }; }) });
  }

  function log(o) { if (DEBUG) console.debug('[tpk-dock v5]', o); }
  function schedule() { if (!raf) raf = requestAnimationFrame(check); }

  /* Icona tonda Toppik Italia AI */
  var ICON = '<svg viewBox="0 0 22.3 21.8" fill="currentColor" aria-hidden="true">' +
    '<path d="M10 2.5l1.6 4.9a3 3 0 0 0 1.9 1.9l4.9 1.6-4.9 1.6a3 3 0 0 0-1.9 1.9L10 19.3l-1.6-4.9a3 3 0 0 0-1.9-1.9L1.6 10.9l4.9-1.6a3 3 0 0 0 1.9-1.9z"/>' +
    '<path d="M18.5 14l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"/></svg>';
  function openChat(chat) {
    var act = chat.shadowRoot && chat.shadowRoot.querySelector('button.activator, .activator');
    if (act) act.click();
    setTimeout(function () {
      if (chat.hasAttribute('open')) return;
      if (typeof chat.show === 'function') { try { chat.show(); } catch (e) {} }
      setTimeout(function () { if (!chat.hasAttribute('open')) chat.setAttribute('open', ''); schedule(); }, 150);
    }, 250);
    schedule();
  }
  function initFab() {
    var chat = document.querySelector('shopify-chat');
    if (!chat || !window.customElements || document.getElementById('tpk-ai-fab')) return;
    customElements.whenDefined('shopify-chat').then(function () {
      /* lascia il tempo al componente di creare il proprio shadow DOM */
      setTimeout(function () {
        if (!chat.shadowRoot) { log({ fab: 'shadow DOM non accessibile: resta il launcher nativo' }); return; }
        var b = document.createElement('button');
        b.id = 'tpk-ai-fab';
        b.type = 'button';
        b.setAttribute('aria-label', 'Toppik Italia AI: chiedi un consiglio');
        b.title = 'Toppik Italia AI';
        b.innerHTML = ICON;
        b.addEventListener('click', function () { openChat(chat); });
        document.body.appendChild(b);
        root.classList.add('tpk-ai-on');
        lastScan = 0; schedule();
      }, 300);
    });
  }

  function boot() {
    initFab();
    scan();
    schedule();
    setInterval(function () { if (!document.hidden) schedule(); }, 400);
    window.addEventListener('resize', function () { lastScan = 0; schedule(); }, { passive: true });
    window.addEventListener('orientationchange', function () { lastScan = 0; schedule(); });
    ['shopify-chat:enter-managed', 'shopify-chat:enter-standalone', 'shopify-chat:close',
     'theme-drawer:open', 'theme-drawer:close', 'rivo-js-loaded', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function () { schedule(); setTimeout(function () { lastScan = 0; schedule(); }, 150); }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
